<h3 class="heading" style="margin-bottom: 20px">
    <!-- Bolt and Pump -->
    {{ 'CALC_OUTPUT.LABEL.BOLT_OUTPUT.BOLT_AND_PUMP' | transloco }}
</h3>
<div>
    <div class="row mt-1 mb-6">
        <div class="col-md-4 text-center">
            <div class="card card-custom" style="padding: 20px 15px">
                <h4 style="font-size: 16px; margin-bottom: 10px">
                    <!-- Residual Bolt Load -->
                    {{ 'CALC_OUTPUT.LABEL.BOLT_OUTPUT.RESIDUAL_BOLT_LOAD' | transloco }}
                </h4>
                <div class="ps-3 pe-3">
                    <h5 class="mt-2 mb-2">{{ resBoltLoad }}</h5>
                </div>
            </div>
        </div>
        <div class="col-md-4 text-center">
            <div class="card card-custom" style="padding: 20px 15px">
                <h4 style="font-size: 16px; margin-bottom: 10px">
                    <!-- Residual Bolt Yield -->
                    {{ 'CALC_OUTPUT.LABEL.BOLT_OUTPUT.RESIDUAL_BOLT_YIELD' | transloco }}
                </h4>
                <div class="ps-3 pe-3">
                    <h5 class="mt-2 mb-2">{{ resboltYield }}</h5>
                </div>
            </div>
        </div>
        <div class="col-md-4 text-center">
            <div class="card card-custom" style="padding: 20px 15px">
                <h4 style="font-size: 16px; margin-bottom: 10px">
                    <!-- Residual Bolt Stress -->
                    {{ 'CALC_OUTPUT.LABEL.BOLT_OUTPUT.RESIDUAL_BOLT_STRESS' | transloco }}
                </h4>
                <div class="ps-3 pe-3">
                    <h5 class="mt-2 mb-2">{{ resBoltStress }}</h5>
                </div>
            </div>
        </div>
    </div>
</div>
